import Phaser from "phaser";
import Stats from "stats.js";

export default class Debug{

    public stats?: Stats;

    constructor(scene: Phaser.Scene, debug: boolean){
        if(debug){
            this.showfps();
        }
    }

    private showfps(): void{
        this.stats = new Stats();
        this.stats.showPanel(0);
        document.body.appendChild(this.stats.dom);
    }

}